export default "/images/vendor/flag-icon-css/flags/4x3/pm.svg?bee2207b45dc0b094dbd9377b3b258d5";